import { Link, useLocation } from "react-router-dom";

const TABS = [
  {
    to: "/today",
    label: "今日",
    icon: (active: boolean) => (
      <svg className={`w-5 h-5 mx-auto ${active ? "text-blue-600" : "text-slate-400"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.2" : "1.8"} strokeLinecap="round" strokeLinejoin="round">
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    to: "/wordbook",
    label: "詞庫",
    icon: (active: boolean) => (
      <svg className={`w-5 h-5 mx-auto ${active ? "text-blue-600" : "text-slate-400"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.2" : "1.8"} strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
        <path d="M6 6h10" />
        <path d="M6 10h10" />
      </svg>
    ),
  },
  {
    to: "/quiz/review",
    label: "練習",
    icon: (active: boolean) => (
      <svg className={`w-5 h-5 mx-auto ${active ? "text-blue-600" : "text-slate-400"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.2" : "1.8"} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
        <path d="M7 7h.01" />
      </svg>
    ),
  },
  {
    to: "/stats",
    label: "統計",
    icon: (active: boolean) => (
      <svg className={`w-5 h-5 mx-auto ${active ? "text-blue-600" : "text-slate-400"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.2" : "1.8"} strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
  {
    to: "/settings",
    label: "我的",
    icon: (active: boolean) => (
      <svg className={`w-5 h-5 mx-auto ${active ? "text-blue-600" : "text-slate-400"}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.2" : "1.8"} strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

export function TabBar() {
  const { pathname } = useLocation();

  return (
    <nav className="w-full border-t border-slate-200/80 bg-white/95 backdrop-blur-md shadow-lg" aria-label="Mobile Navigation">
      <div className="w-full max-w-lg mx-auto flex items-center justify-around px-2 py-2 pb-[max(10px,env(safe-area-inset-bottom))]">
        {TABS.map((item) => {
          const active = pathname === item.to || (item.to !== "/today" && pathname.startsWith(item.to));
          return (
            <Link
              key={item.to}
              to={item.to}
              aria-current={active ? "page" : undefined}
              className={`flex-1 flex flex-col items-center justify-center py-1 no-underline transition-all ${
                active ? "text-blue-600 font-bold" : "text-slate-500 hover:text-slate-800"
              }`}
            >
              {item.icon(active)}
              <span className={`text-[11px] mt-1 leading-none ${active ? "font-bold text-blue-600" : "font-medium text-slate-500"}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default TabBar;
